// "Look around" (VIS-265, Film's action at a point; also a tour stop's move): the camera stays where it is and turns
// on the spot, as a person turning their head. At rest when it begins and ends.
// Options:
//   turn    degrees it turns, + = to the right (clockwise seen from above), - = to the left (default 45)
//   travel  seconds of the flight to a tour stop (default 3.2)
import { easeInOut, posed, turnAbout } from './rig.js';

/** @param {import('./rig.js').View} view  @param {number} k  0..1 of the move  @returns {import('./rig.js').View} */
export function pose(view, k, o = {}) {
  const deg = (Number.isFinite(o.turn) ? o.turn : 45) * easeInOut(Math.min(1, Math.max(0, k)));
  return { ...view, target: turnAbout(view.target, view.position, deg) };
}

export default function lookAround(o, rig) { return posed(pose, o, rig); }
